import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DadosUnidade } from 'src/app/models/Servico.model';

@Component({
  selector: 'app-header-unidade',
  templateUrl: './header-unidade.component.html',
  styleUrls: ['./header-unidade.component.css'],
})
export class HeaderUnidadeComponent {
  @Input({ required: true }) dadosUnidade?: DadosUnidade;
  @Output() sair = new EventEmitter();

  sairHandle() {
    this.sair.emit();
  }
}
